import React from 'react';
import Logo from '../../../assets/flyscanLogo.png';
import useStyles from './FlyscanLogo.styles';

const FlyscanLogo = () => {
  const classes = useStyles();

  return <img src={Logo} className={classes.root} alt="logo." />;
};

export default React.memo(FlyscanLogo);
